var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6,
    rx: 6,
    ry: 6,
    fill: "#818181"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64302 3.33905C8.86912 3.0968 9.24879 3.08371 9.49104 3.30981C9.73329 3.53591 9.74638 3.91558 9.52028 4.15783L5.32028 8.65783C5.10092 8.89287 4.73528 8.91322 4.49118 8.70399L2.39118 6.90399C2.13958 6.68834 2.11044 6.30956 2.3261 6.05796C2.54175 5.80637 2.92053 5.77723 3.17213 5.99289L4.83545 7.41859L8.64302 3.33905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.65eff656a8570cf01127be9afc6164a4.svg";
export { ForwardRef as ReactComponent };